import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunecorporatecab() {



  const cardData =
  {
    keyword: 'Mumbai to Pune Corporate Cab',
    heading: 'Aaryan Travels: Mumbai to Pune Corporate Cab',
    headingDescription: ' Aaryan Travels offers premium Mumbai to Pune Corporate Cab services designed specifically for business professionals, company executives, and corporate travel requirements. Whether it’s client transfers, factory visits, airport pickups, or executive drop-offs between Mumbai and Pune, our fleet of well-maintained sedans, SUVs, and luxury cabs ensures a smooth and productive travel experience. With uniformed chauffeurs, Wi-Fi-enabled vehicles (on request), and guaranteed punctuality, we provide a seamless journey across the Mumbai-Pune Expressway. Book one-way or round-trip corporate cabs with monthly billing and dedicated support for recurring travel. For dependable and professional corporate cab services between Mumbai and Pune, Aaryan Travels is your trusted partner.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


"services": [
  {
    "name": "Mumbai to Pune Corporate Cab",
    "description": "Our Mumbai to Pune Corporate Cab service is designed to provide businesses with reliable and professional transportation solutions. Whether it's for daily employee commutes, business meetings, or corporate events, we offer a fleet of premium vehicles with experienced drivers who understand the corporate culture and prioritize punctuality and comfort."
  },
  {
    "name": "Intercity Corporate Cab Mumbai Pune",
    "description": "Travel smoothly between Mumbai and Pune with our Intercity Corporate Cab service. Tailored for corporate clients, this service offers flexible scheduling, executive cars, and professional chauffeurs to ensure timely and comfortable travel for business executives, staff, and VIPs."
  },
  {
    "name": "Business Cab Hire Mumbai Pune",
    "description": "Hire business cabs from Mumbai to Pune that cater specifically to professional needs. Our fleet includes sedans and SUVs equipped with modern amenities, providing a premium travel experience for business travelers who value efficiency, comfort, and professionalism."
  },
  {
    "name": "Chauffeur Cab Mumbai to Pune",
    "description": "Enjoy the convenience of a chauffeur-driven cab service from Mumbai to Pune. Our chauffeurs are trained to offer discreet, safe, and timely transportation, making your journey relaxing and productive. Ideal for executives and corporate clients needing hassle-free travel."
  },
  {
    "name": "Corporate Sedan Mumbai to Pune",
    "description": "Choose our Corporate Sedan service for a sleek, comfortable ride from Mumbai to Pune. Our sedans are well-maintained, air-conditioned, and equipped with features suited for business travel, including Wi-Fi and charging ports to keep you connected on the go."
  },
  {
    "name": "Corporate SUV Hire Mumbai Pune",
    "description": "For group travel or extra luggage space, our Corporate SUV Hire service from Mumbai to Pune offers spacious and luxurious vehicles. Perfect for corporate teams, VIPs, or clients who require both comfort and style during their intercity commute."
  },
  {
    "name": "Executive Taxi Mumbai Pune",
    "description": "Our Executive Taxi service provides top-tier vehicles with premium interiors and professional drivers to ensure a sophisticated travel experience between Mumbai and Pune. Enjoy privacy, punctuality, and personalized service tailored for executives and business travelers."
  },
  {
    "name": "Affordable Corporate Cab Mumbai Pune",
    "description": "Get cost-effective corporate cab solutions from Mumbai to Pune without compromising on quality or professionalism. Our affordable cabs are perfect for startups, SMEs, and businesses seeking reliable transportation within budget."
  },
  {
    "name": "Mumbai to Pune Staff Transport",
    "description": "Efficient and safe staff transport services from Mumbai to Pune, designed to meet corporate requirements for employee commutes. Our fleet includes comfortable vehicles with flexible pick-up and drop-off schedules to suit shift timings and office hours."
  },
  {
    "name": "Office Cab Mumbai to Pune",
    "description": "Our Office Cab service from Mumbai to Pune focuses on providing timely and dependable transportation for office employees. With comfortable seating, professional drivers, and well-planned routes, this service reduces commute stress and enhances punctuality."
  },
  {
    "name": "Corporate Car Mumbai Pune",
    "description": "Choose from a range of corporate cars for your Mumbai to Pune travel needs. Our fleet features modern, well-maintained vehicles driven by experienced chauffeurs, ensuring a smooth and professional journey tailored for business clients."
  },
  {
    "name": "Premium Corporate Cab Mumbai Pune",
    "description": "Experience luxury with our Premium Corporate Cab service between Mumbai and Pune. Featuring high-end vehicles, superior customer service, and exclusive amenities, this service is ideal for VIP clients and important corporate events."
  },
  {
    "name": "Monthly Corporate Cab Mumbai Pune",
    "description": "Opt for our Monthly Corporate Cab service for regular and long-term transportation solutions between Mumbai and Pune. Flexible plans, priority bookings, and dedicated vehicles make this service perfect for companies seeking dependable commuting options."
  },
  {
    "name": "Online Booking Corporate Cab Mumbai Pune",
    "description": "Book your corporate cab from Mumbai to Pune quickly and securely through our online platform. Enjoy instant confirmations, transparent pricing, and easy management of bookings, making business travel planning hassle-free."
  },
  {
    "name": "Reliable Business Cab Mumbai Pune",
    "description": "Our Reliable Business Cab service offers consistent, punctual, and professional transportation between Mumbai and Pune. With well-maintained vehicles and experienced drivers, this service is tailored to meet the demanding schedules of business travelers."
  }
],
"tableData": [
  ["Mumbai to Pune Corporate Cab", "Intercity Corporate Cab Mumbai Pune"],
  ["Business Cab Hire Mumbai Pune", "Chauffeur Cab Mumbai to Pune"],
  ["Corporate Sedan Mumbai to Pune", "Corporate SUV Hire Mumbai Pune"],
  ["Executive Taxi Mumbai Pune", "Affordable Corporate Cab Mumbai Pune"],
  ["Mumbai to Pune Staff Transport", "Office Cab Mumbai to Pune"],
  ["Corporate Car Mumbai Pune", "Premium Corporate Cab Mumbai Pune"],
  ["Monthly Corporate Cab Mumbai Pune", "Online Booking Corporate Cab Mumbai Pune"],
  ["Reliable Business Cab Mumbai Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Professional Corporate Cab Services from Mumbai to Pune",
    "WhyChoosedescription": "Aaryan Travels provides dependable and timely corporate cab services for your Mumbai to Pune business travel."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Corporate Travelers",
    "WhyChoosedescription": "Our drivers ensure on-time pickups and drops, making your business commute smooth and stress-free."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars designed for a professional and comfortable journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Pune Corporate Routes",
    "WhyChoosedescription": "Our drivers know the best routes between Mumbai and Pune to ensure efficient and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with Corporate Invoicing",
    "WhyChoosedescription": "Enjoy upfront pricing with GST-compliant invoices, covering all travel expenses without hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Corporate Bookings",
    "WhyChoosedescription": "Our support team is available round the clock to assist with corporate travel arrangements."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Business Needs",
    "WhyChoosedescription": "Choose from one-way rides, round trips, or monthly contracts tailored to your corporate travel requirements."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles Suitable for Corporate Travel",
    "WhyChoosedescription": "Select from sedans, SUVs, or luxury cars depending on your team size and comfort preferences."
  }
]

















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services from Mumbai to Pune?',
    answer: 'Yes, Aaryan Travels provides professional and reliable corporate cab services for travel between Mumbai and Pune.',
  },
  {
    question: 'How can I book corporate cab services from Mumbai to Pune with Aaryan Travels?',
    answer: 'You can book corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services from Mumbai to Pune?',
    answer: 'Aaryan Travels offers a wide fleet including sedans, SUVs, and premium cars suitable for executive and employee transportation.',
  },
  {
    question: 'Are corporate cab services suitable for daily employee commute between Mumbai and Pune?',
    answer: 'Yes, we provide customized corporate cab solutions for daily employee pickups and drops on the Mumbai-Pune route.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements between Mumbai and Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and well-versed with corporate travel standards on this route.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group cab bookings for corporate events between Mumbai and Pune?',
    answer: 'Yes, we specialize in managing group transportation and bulk cab bookings for corporate meetings, events, and conferences.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for corporate cab services between Mumbai and Pune?',
    answer: 'Yes, we provide flexible billing options including monthly invoicing for our corporate clients.',
  },
  {
    question: 'Is corporate cab service from Mumbai to Pune available 24x7?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services between Mumbai and Pune.',
  },
  {
    question: 'What safety measures are in place for corporate cab services between Mumbai and Pune?',
    answer: 'All vehicles undergo regular sanitization and safety checks, and our drivers follow strict safety protocols.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings from Mumbai to Pune?',
    answer: 'Yes, we allow full customization of pickup and drop points based on your corporate travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajiv Mehta',
    feedback: 'Aaryan Travels’ corporate cab service between Mumbai and Pune has been very reliable and professional for our employee transport.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    feedback: 'Great corporate cab service from Mumbai to Pune by Aaryan Travels. Always punctual and courteous drivers.',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Corporate Cab",
  "image": "https://aaryantravels.com/assets/images/mumbai-pune-corporate-cab.jpg", // replace with actual image URL
  "description": "Professional and affordable Mumbai to Pune corporate cab services by Aaryan Travels. Perfect for business travel, staff transport, and executive rides with sedan and SUV options. Book online for reliable corporate cab hire.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating, update as needed
    "ratingCount": "3500", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/mumbai-to-pune-corporate-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Mumbai to Pune Corporate Cab | Business & Executive Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Professional and affordable Mumbai to Pune corporate cab services by Aaryan Travels. Perfect for business travel, staff transport, and executive rides with sedan and SUV options. Book online for reliable corporate cab hire."
  />
  <meta
    name="keywords"
    content="Mumbai to Pune Corporate Cab, Intercity Corporate Cab Mumbai Pune, Business Cab Hire Mumbai Pune, Chauffeur Cab Mumbai to Pune, Corporate Sedan Mumbai to Pune, Corporate SUV Hire Mumbai Pune, Executive Taxi Mumbai Pune, Affordable Corporate Cab Mumbai Pune, Mumbai to Pune Staff Transport, Office Cab Mumbai to Pune, Corporate Car Mumbai Pune, Premium Corporate Cab Mumbai Pune, Monthly Corporate Cab Mumbai Pune, Online Booking Corporate Cab Mumbai Pune, Reliable Business Cab Mumbai Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunecorporatecab;